<template>
  <div class="page flex-col">
    <div class="box_2 flex-col">
      <div class="block_2 flex-col">
        <div class="group_2 flex-col">
          <div class="section_5 flex-row">
            <div class="group_3 flex-col">
              <span class="paragraph_2">
                刷
                <br />
                <br />
                题
              </span>
              <img
                class="image_1"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPnga8b871c5bd16ec2783b3e2d8f8a9b404def659648458943de6a7f6c07128a561.png"
              />
            </div>
            <span class="paragraph_1">
              刷
              <br />
              <br />
              题
            </span>
          </div>
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng45402e502be3756b3ec36ec85364510fdf9d87e2b1d0ef1122bc243475b21f38.png"
          />
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng03aadd83c9256b6ad18eb75018f06b02867ec713844f8dce9e5ce8c18034a905.png"
          />
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5607a3d3f6693465189064a56f004b228eb92c9f7e910ba87de85d3f3f047454.png"
          />
        </div>
      </div>
      <div class="section_2 flex-col">
        <div class="text-group_2 flex-col">
          <span class="text_1">一、ArrayList和LinkedList的区别？</span>
          <span class="text_2">
            请输入您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案您的答案
          </span>
        </div>
        <div class="section_6 flex-row justify-between">
          <div class="text-wrapper_1 flex-col"><span class="text_3">上一题</span></div>
          <div class="text-wrapper_2 flex-col"><span class="text_4">下一题</span></div>
        </div>
      </div>
      <div class="block_3 flex-col">
        <div class="text-wrapper_3 flex-col"><span class="text_5">开始考试</span></div>
      </div>
      <div class="section_4 flex-col">
        <span class="text_6">姓名</span>
        <div class="text-wrapper_4 flex-col"><span class="text_7">输入姓名</span></div>
        <span class="text_8">手机号</span>
        <div class="text-wrapper_5 flex-col"><span class="text_9">输入手机号</span></div>
        <span class="text_10">岗位</span>
        <div class="group_1 flex-row justify-between">
          <span class="text_11">UI工程师</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngfa53d53aebef0e60949481586f0df26200f9d010386c4053c558046a8eac9f91.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />